import styled from "styled-components";
import { Dropdown } from "react-bootstrap";

export const CancelButton = styled.button`
  border: 2px solid #000FFF;
  color: #000FFF;
  font-size: 1rem;
  font-weight: 550;
  background-color: white;
  width: 90%;
  padding: 0.5rem;
  border-radius: 0.4rem;
  margin: 0.5rem 1rem 1rem 1rem;
  box-shadow: 2px 4px 6px #00000033;
`;

export const TextCancel = styled.h3`
  font-size: 1.3rem;
  color: #000FFF;
  font-weight: 500;
  margin: ${(props) => props.margin};
  text-align: center;
`;

export const AlignButtonsCancel = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  flex-direction: row;
`;

export const ButtonCancelYes = styled.button`
  width: 47%;
  height: 45px;
  background-color: #ffffff;
  border-radius: 0.2rem;
  font-size: 1rem;
  font-weight: 550;
  color: #000FFF;
  text-align: center;
  margin: 0.5rem 1rem 1rem 0.5rem;
  border: 2px solid #000FFF;
  box-shadow: 2px 4px 6px #00000033;
  border-radius: 10px;
  transition: 0.5s;
  img {
    float: left;
    margin-top: 5px;
    padding-left: 0.5rem;
    width: 25px;
    fill: #000FFF;
  }
  span {
    font-size: 17px;
    padding-right: 1.1rem;
  }
`;

export const ButtonCancelNo = styled.button`
  width: 47%;
  height: 45px;
  background-color: #000FFF;
  border-radius: 0.2rem;
  font-size: 1rem;
  font-weight: 550;
  color: #ffffff;
  text-align: center;
  margin: 0.5rem 1rem 1rem 0.5rem;
  border: 2px solid #000FFF;
  box-shadow: 2px 4px 6px #00000033;
  border-radius: 10px;
  transition: 0.5s;
  img {
    float: left;
    margin-top: 5px;
    padding-left: 0.5rem;
    width: 23px;
    fill: #000FFF;
  }
  span {
    font-size: 17px;
    padding-right: 1.1rem;
  }
`;

export const CancelTextArea = styled.textarea`
  width: 90%;
  border: 1px solid #00000034;
  border-radius: 0.5rem;
  resize: none;
  padding: 0.5rem;
  height: 8rem;
  margin: 0.5rem 1rem 0 1rem;
`;

export const CancelDropdown = styled.div`
  background-color: #fff;
  width: 75vw;
  height: 25%;
  padding: 5%;
  margin: 10% auto 10% auto;
  display: flex;
  flex-direction: row;
  border-radius: 16px;
  align-items: center;
  justify-content: space-between;
  box-shadow: 0px 3px 6px #00000066;
  justify-content: space-between;

  @media (min-width: 768px) {
    width: 100%;
  }
`;

export const DropdownMenuEconomic = styled(Dropdown.Menu)`
  max-height: 300px;
  overflow: auto;
  margin-top: -15px;
  border-bottom-left-radius: 20px;
  border-bottom-right-radius: 20px;
  border-width: 0px;
  box-shadow: 0px 18px 17px 3px #00000066;
  width: 100%;
  left: 0.5px !important;

  @media(max-width: 770px) {
    width: 75vw;
  }
`;
